import { render, staticRenderFns } from "./PatternExtension2Form.vue?vue&type=template&id=0640aea7&"
import script from "./PatternExtension2Form.vue?vue&type=script&lang=js&"
export * from "./PatternExtension2Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports